import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

export function Modal({ isOpen, onClose, children, title }: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 md:p-20">
      <div className="fixed inset-0 bg-dark/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-3xl max-h-[90vh] flex flex-col bg-[#1a1a1a] rounded-xl shadow-xl overflow-hidden">
        <div className="absolute right-4 top-4 z-10">
          <button
            aria-label="Schliessen"
            onClick={onClose}
            className="p-2 text-light/60 hover:text-light transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        {title && (
          <div className="px-6 py-4 border-b border-gray-custom/10">
            <h2 className="text-xl font-semibold text-light">{title}</h2>
          </div>
        )}
        <div className="p-6 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
}